/**
 * The single period key each boss tier's cell operates on — extracted from `routes/Bosses.tsx`
 * (REV16, docs/specs/REV16-clearboss-and-toastify.md) so the `clearboss` command palette action
 * can reuse the exact same rule instead of re-deriving it. WEEKLY uses the caller's `weekKey`
 * itself (Bosses.tsx: the viewed week, backfillable to any past week; the command palette: always
 * the current week, since `clearboss` only ever targets the live matrix). DAILY always means
 * *today*. MONTHLY prefers the current calendar month when the viewed week overlaps it, else the
 * first month the week overlaps (see WP6 Deviations for the "most relevant of the available keys"
 * judgment call).
 */
import type { BossTierValue } from './bosses';

export interface PeriodKeyInputs {
  /** WEEKLY tier's period key. */
  weekKey: string;
  /** DAILY tier's period key — always the caller's notion of "today". */
  todayIso: string;
  /** The current calendar month, preferred for MONTHLY when the viewed week overlaps it. */
  currentMonthKeyIso: string;
  /** The matrix response's `monthlyKeys` — the month(s) the viewed week's data actually covers. */
  monthlyKeys: string[];
}

export function periodKeyForTier(tier: BossTierValue, inputs: PeriodKeyInputs): string {
  if (tier === 'WEEKLY') {
    return inputs.weekKey;
  }
  if (tier === 'DAILY') {
    return inputs.todayIso;
  }
  return inputs.monthlyKeys.includes(inputs.currentMonthKeyIso)
    ? inputs.currentMonthKeyIso
    : (inputs.monthlyKeys[0] ?? inputs.currentMonthKeyIso);
}
